<template>
<div class="filter-bar">
  <div class="popular-box">
    <van-dropdown-menu active-color="#DD3131">
      <van-dropdown-item
        v-model="popular" 
        :options="sortList" 
      />
      <van-dropdown-item disabled>
        <template #title>
          <span class="filter-label" @click="filterShow = true">
            <span>Filter</span>
            <van-icon name="filter-o" />
          </span>
        </template>
      </van-dropdown-item>
    </van-dropdown-menu>
  </div>
</div>

<FilterPopup
  v-model:show="filterShow"
  :filter="filter"
  :defaultParams="defaultParams || {}"
  @filter:apply="handleFilterApplyChange" 
/>
</template>

<script setup lang="ts">
import FilterPopup from './FilterPopup.vue'
import { type ISearchParams } from '@/api/models/system'

interface IPopularType { text: string, value: string | number }
interface IProps { filter: any, defaultParams?: ISearchParams }
defineProps<IProps>()
const emits = defineEmits<{
  (event: 'search:change', params: ISearchParams):void
}>()

const sortList: IPopularType[] = [
  { text: 'Popular', value: '' },
  { text: 'Price Up', value: 1 },
  { text: 'Price Down', value: 2 },
  { text: 'Top Sale', value: 4 }, // 3
  { text: 'Latest', value: 9 }
]
const filterShow = ref<boolean>(false)
const popular = ref<string | number>('')

let cacheSearchParams: IAnyObject = {}
let cacheSortBy: any = ''
watch(
  () => popular.value,
  (sortBy) => {
    cacheSortBy = sortBy
    emits('search:change', { sortBy, ...cacheSearchParams })
  }
)
const handleFilterApplyChange = (params: ISearchParams) => {
  cacheSearchParams = params

  emits('search:change', { sortBy: cacheSortBy, ...cacheSearchParams })
}
</script>

<style lang="scss" scoped>
.filter-bar{
  font-size: 28px;
}
.filter-bar :deep(.van-dropdown-menu__title){
  color: #DD3131;
  &:after {
    border-color: transparent transparent #DD3131 #DD3131;
  }
}
.filter-bar :deep(.van-dropdown-menu__item--disabled){
  color: #333;
  .van-dropdown-menu__title:after{
    display: none;
  }
}
.filter-label{
  color: #333;
}
</style>